import { render, staticRenderFns } from "./addmangesb.vue?vue&type=template&id=2f085d53&scoped=true"
import script from "./addmangesb.vue?vue&type=script&lang=js"
export * from "./addmangesb.vue?vue&type=script&lang=js"
import style0 from "./addmangesb.vue?vue&type=style&index=0&id=2f085d53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f085d53",
  null
  
)

export default component.exports